module.exports = __webpack_public_path__ + "static/media/arrow-left-black.29b097f7.svg";